
import { Vue } from "vue-class-component";

export default class Container extends Vue {}
